import { i18n } from '@/locales';
const lc = 'views.hub_management.';
// 고객 SMS여부
// https://www.notion.so/barogohq/806c2bbff42240b5af0e3280230135ba?p=a1d8d9a6ea58472fad3472aceae36f2d&pm=s
// Y -> 전체 문자 전송 O
// X -> 전체 문자 전송 X
// N -> 비대면 완료만 전송 O
const isCustomerMessageServiceOptionList = [
    'Y',
    'X',
    'N',
];
export default isCustomerMessageServiceOptionList.map((code, index) => ({
    text: i18n.t(`${lc}hub_configuration.options.is_customer_message_service_type_list[${index}]`),
    value: code,
}));
